export type ClearingDocType = 'shipping' | 'clearing' | 'bank'

export interface ClearingDocItem {
  id: string
  name: string
  url: string
  type: string | null
}

interface ClearingDocumentCellProps {
  docs: ClearingDocItem[]
  uploading: boolean
  onUpload: () => void
  onViewList: () => void
  onViewDoc: (doc: ClearingDocItem) => void
  uploadTitle?: string
}

const ClearingDocumentCell = ({
  docs,
  uploading,
  onUpload,
  onViewList,
  onViewDoc,
  uploadTitle = 'Upload PDF(s)',
}: ClearingDocumentCellProps) => (
  <div className="flex items-center gap-1">
    <button
      type="button"
      onClick={onUpload}
      disabled={uploading}
      className="flex items-center justify-center hover:opacity-80 rounded transition-colors disabled:opacity-60 disabled:cursor-not-allowed"
      title={uploadTitle}
      style={{
        backgroundColor: '#F2F4F2',
        width: '26px',
        height: '26px',
        padding: '0',
        border: '1px solid #E9E9EA',
        borderRadius: '6px',
      }}
    >
      <img src="/images/add.svg" alt="Upload" style={{ width: '14px', height: '14px' }} />
    </button>
    {docs.length > 0 && (
      <button
        type="button"
        onClick={onViewList}
        className="flex items-center justify-center hover:opacity-80 rounded transition-colors"
        title="View documents"
        style={{
          backgroundColor: '#EAF1FF',
          width: '26px',
          height: '26px',
          padding: '0',
          border: '1px solid #E9E9EA',
          borderRadius: '6px',
        }}
      >
        <img src="/images/document-text.svg" alt="View documents" style={{ width: '14px', height: '14px' }} />
      </button>
    )}
    {docs.length > 0 && (
      <button
        type="button"
        onClick={() => onViewDoc(docs[0])}
        className="flex items-center justify-center hover:opacity-80 rounded transition-colors"
        title="Open first document"
        style={{
          backgroundColor: '#E8F7EF',
          width: '26px',
          height: '26px',
          padding: '0',
          border: '1px solid #E9E9EA',
          borderRadius: '6px',
        }}
      >
        <img src="/images/download.svg" alt="Open" style={{ width: '14px', height: '14px' }} />
      </button>
    )}
    {docs.length > 0 && (
      <span
        style={{
          fontFamily: 'Lexend Deca',
          fontSize: '11px',
          fontWeight: 500,
          color: '#13AB5B',
          backgroundColor: '#E8F7EF',
          borderRadius: '10px',
          padding: '2px 6px',
          whiteSpace: 'nowrap',
        }}
      >
        {docs.length}
      </span>
    )}
    {uploading && (
      <span style={{ fontFamily: 'Lexend Deca', fontSize: '11px', color: '#69697A' }}>…</span>
    )}
  </div>
)

export default ClearingDocumentCell
